import React, {Component} from "react";
import './CurrencyPrivat.scss'
import flagUS from '../assets/images/flag_united_states.ico'
import flagEU from '../assets/images/flag_europe.ico'
import flagRU from '../assets/images/flag_russia.ico'
import flagPL from '../assets/images/flag_poland.ico'
import flagUA from '../assets/images/flag_ukraine.ico'
import privatBankLogo from '../assets/images/privat-bank-logo.png'

class CurrencyPrivat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        // Try an alternative CORS proxy
        let url = "https://api.allorigins.win/raw?url=" + encodeURIComponent("https://api.privatbank.ua/p24api/pubinfo?json&exchange&coursid=11");
        
        fetch(url)
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json().catch(e => {
                    throw new Error('Invalid JSON response from server');
                });
            })
            .then(result => {
                this.setState({
                    isLoaded: true,
                    items: result
                });
            })
            .catch(error => {
                this.setState({
                    isLoaded: true,
                    error: {
                        message: error.message || 'Failed to fetch currency data'
                    }
                });
            });
    }

    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            return <div>Ошибка: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Загрузка...</div>;
        } else if (Array.isArray(items)) {

            function getIcoCurrency(ico_code_name) {
                let icoCurrency = "";
                switch (ico_code_name) {
                    case "EUR":
                        return icoCurrency = flagEU;
                    case "USD":
                        return icoCurrency = flagUS;
                    case "BTC":
                        return icoCurrency = flagPL;
                    case "RUR":
                        return icoCurrency = flagRU;
                    default:
                        return icoCurrency = flagUA;
                }
            }

            return (
                <div className='currency'>
                    <div className='logo-bank'>
                        <img src={privatBankLogo}/>
                    </div>
                    <div>
                        <div className='currency-item-header'>
                            <div> </div>
                            <div>Покупка</div>
                            <div>Продажа</div>
                        </div>
                        {items.map((item, index) => (
                            <div key={index}>
                                {item.ccy === "USD" || item.ccy === "EUR" || item.ccy === "RUR" ?
                                    <div className='currency-item-container'>
                                        <div className="currency-item currency-item-left">
                                            <div><img className="currency-icon" src={getIcoCurrency(item.ccy)} alt="currency ico" /></div>
                                            <div>{item.ccy + ' / ' + item.base_ccy}</div>
                                        </div>
                                        <div className="currency-item">
                                            <div className='currency-value'>{((parseInt(item.buy * 100)) / 100).toFixed(2)}</div>
                                            <div className='currency-value'>{((parseInt(item.sale * 100)) / 100).toFixed(2)}</div>
                                        </div>
                                    </div>
                                    :
                                    ''
                                }
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
        else {
            return (
                <div>
                    { (Array.isArray(items))
                        ? ""
                        : 'Ошибка: ' + items.errorDescription + '. Попробуйте чуть позже.'
                    }
                </div>
            )
        }
    }

}

export default CurrencyPrivat;
